import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Col, Form } from "react-bootstrap";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import { isValidDateFormat, preventNonDigitCharacters } from "../../utils/common";

class VerifyWithDL extends Component {
  constructor(props) {
    super(props);
    const { sn, givenName, userName } = props.userInfo || {};
    this.state = {
      givenName: givenName || "",
      sn: sn || "",
      userName: userName || "",
      givenNameError: "",
      snError: "",
      dateOfBirth: "",
      dateOfBirthError: "",
      ssn: "",
      ssnError: "",
      dlNumber: "",
      dlNumberError: "",
      stateIdNumber: "",
      stateIdNumberError: "",
      streetNumber: "",
      streetNumberError: "",
    };
  }

  onFirstAndLastNameChange = (e, key) => {
    const value = e.target.value.trim();
    if (value.match(/^[a-zA-Z '`,.-]*$/)) {
      this.setState({
        [key]: value,
      });
    }
  };

  onNextClick = (e) => {
    e.preventDefault();
    const { onNext, onError } = this.props;
    const {
      givenNameError,
      snError,
      dateOfBirthError,
      ssnError,
      dlNumberError,
      stateIdNumberError,
      streetNumberError,
      ...verifyWithDL
    } = this.state;
    const {
      givenName, sn, ssn, dateOfBirth, dlNumber, stateIdNumber, streetNumber
    } = verifyWithDL;
    
    const hasGivenName = this.isFormFieldValid(givenName, "givenNameError");
    const hasSn = this.isFormFieldValid(sn, "snError");
    const hasSsn = this.isFormFieldValid(ssn, "ssnError");
    const hasDateOfBirth = this.isFormFieldValid(dateOfBirth, "dateOfBirthError");
    const hasDlNumber = this.isFormFieldValid(
      dlNumber,
      "dlNumberError"
    );
    const hasStateIdNumber = this.isFormFieldValid(stateIdNumber, "stateIdNumberError");
    const hasStreetNumber = this.isFormFieldValid(streetNumber, "streetNumberError");

    if (
      hasGivenName ||
      hasSn ||
      hasSsn ||
      hasDateOfBirth ||
      hasStreetNumber ||
      (
        hasDlNumber &&
        hasStateIdNumber
      )
    ) {
      onError("common.errors.required");
    } else {
      onNext(e, { verifyWithDL });
    }
  };

  isFormFieldValid = (e, key) => {
    const value = e.target ? e.target.value.trim() : e;

    const { dlNumber, stateIdNumber } = this.state;

    let dependentFieldError = "";

    let errorMsg = "";
    switch (key) {
      case "givenNameError":
        if (value.length <= 0) {
          errorMsg = "common.errors.firstNameError";
        }
        break;
      case "snError":
        if (value.length <= 0) {
          errorMsg = "common.errors.lastNameError";
        }
        break;
      case "dateOfBirthError":
        if (value.length <= 0) {
          errorMsg = "common.errors.dateOfBirthReqd";
        } else if (!isValidDateFormat(value)) {
          errorMsg = "common.errors.dateOfBirthFormat";
        }
        break;
      case "ssnError":
        if (value.length <= 0) {
          errorMsg = `common.errors.${key}`;
        }
        break;
      case "dlNumberError":
        if (value.length <= 0 && stateIdNumber.length <= 0) {
          errorMsg = `common.errors.${key}`;
        } else {
          dependentFieldError = 'stateIdNumberError';
        }
        break;
      case "stateIdNumberError":
        if (value.length <= 0 && dlNumber.length <= 0) {
          errorMsg = `common.errors.${key}`;
        } else {
          dependentFieldError = 'dlNumberError';
        }
        break;
      case "streetNumberError":
        if (value.length <= 0) {
          errorMsg = `common.errors.${key}`;
        }
        break;
      default:
        errorMsg = "";
        break;
    }
    this.setState({
      [key]: errorMsg,
      [dependentFieldError]: '',
    });
    return errorMsg;
  };

  onDobChange = (e, key) => {
    let value = e.target.value.trim();
    this.setState((prevState) => {
      const prevValue = prevState[key];
      if (prevValue.length < value.length) {
        if (value.length === 2 || value.length === 5) {
          value += "/";
        }
      }
      return {
        ...prevState,
        [key]: value,
      };
    });
  };

  onFieldValueChange = (e, key) => {
    const value = e.target.value.trim().toLowerCase();
    let exState = {};
    if (key === "dlNumber") {
      exState = {
        stateIdNumber: "",
      }
    } else if (key === "stateIdNumber") {
      exState = {
        dlNumber: "",
      }
    }

    this.setState({
      ...exState,
      [key]: value,
    });
  };

  handleKeyPress = (e) => {
    preventNonDigitCharacters(e);
  };

  render() {
    const {
      t, title, desc, onBack
    } = this.props;
    const {
      givenName,
      sn,
      givenNameError,
      snError,
      dateOfBirth,
      dateOfBirthError,
      ssn,
      ssnError,
      dlNumber,
      dlNumberError,
      stateIdNumber,
      stateIdNumberError,
      streetNumber,
      streetNumberError,
    } = this.state;
    return (
      <Form>
        <div className="wrapper__container-card-body">
          <h1 className="wrapper__container-card-body-title">{t(title)}</h1>
          <p className="wrapper__container-card-body-desc">{t(desc)}</p>
          <div className="wrapper__container-card-body-dl-verification">
            <Form.Row>
              <Col className="pr-2" lg={{ span: 6 }}>
                <Form.Group controlId="firstName">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.firstName")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFirstAndLastNameChange(e, "givenName");
                    }}
                    value={givenName}
                    maxLength="40"
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "givenNameError");
                    }}
                    className={givenNameError ? "error-input" : undefined}
                  />
                  <p className="error-text">
                    {givenNameError && t(givenNameError)}
                  </p>
                </Form.Group>
              </Col>
              <Col className="pl-2" lg={{ span: 6 }}>
                <Form.Group controlId="lastName">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.lastName")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFirstAndLastNameChange(e, "sn");
                    }}
                    value={sn}
                    maxLength="80"
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "snError");
                    }}
                    className={snError ? "error-input" : undefined}
                  />
                  <p className="error-text">{snError && t(snError)}</p>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col className="pr-2" lg={{ span: 4 }}>
                <Form.Group controlId="dateOfBirth">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.dateOfBirth")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onDobChange(e, "dateOfBirth");
                    }}
                    value={dateOfBirth}
                    onKeyDown={this.handleKeyPress}
                    placeholder={t(
                      "pages.identity.verifyWithDL.dobPlaceholder"
                    )}
                    maxLength={10}
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "dateOfBirthError");
                    }}
                    className={dateOfBirthError ? "error-input" : undefined}
                  />
                  <p className="error-text">
                    {dateOfBirthError && t(dateOfBirthError)}
                  </p>
                </Form.Group>
              </Col>
            </Form.Row>
            <div className="row-separator" />
            <Form.Row>
              <Col className="pr-2" lg={{ span: 6 }}>
                <Form.Group controlId="streetNumber">
                  <Form.Label>
                    {t("pages.identity.streetNumber")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFieldValueChange(e, "streetNumber");
                    }}
                    value={streetNumber}
                    placeholder={t("pages.identity.streetNumberPlaceholder")}
                    maxLength={4}
                    onKeyDown={this.handleKeyPress}
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "streetNumberError");
                    }}
                    className={streetNumberError ? "error-input" : undefined}
                  />
                  <p className={`error-text-bottom-space ${streetNumberError ? "error-text" : "info-text"}`}>{streetNumberError ? t(streetNumberError) : t("pages.identity.streetNumberInfo")}</p>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col className="pr-2" lg={{ span: 6 }}>
                <Form.Group controlId="ssn">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.ssnLastDigits")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFieldValueChange(e, "ssn");
                    }}
                    value={ssn}
                    placeholder="####"
                    maxLength={4}
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "ssnError");
                    }}
                    className={ssnError ? "error-input" : undefined}
                  />
                  <p className="error-text">{ssnError && t(ssnError)}</p>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col className="pr-2 align-self-lg-end" lg={{ span: 5 }}>
                <Form.Group controlId="dlNumber">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.dlNumber")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFieldValueChange(e, "dlNumber");
                    }}
                    value={dlNumber}
                    placeholder="#########"
                    maxLength="9"
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "dlNumberError");
                    }}
                    className={
                      dlNumberError
                        ? "error-input form-with-card-icon"
                        : "form-with-card-icon"
                    }
                  />
                  <p className="error-text">
                    {dlNumberError && t(dlNumberError)}
                  </p>
                </Form.Group>
              </Col>
              <Col lg={{ span: 2 }} className="col-separator">
                <div className="col-separator-body">
                  {t("pages.identity.verifyWithDL.or")}
                </div>
              </Col>
              <Col className="pl-2 align-self-lg-end" lg={{ span: 5 }}>
                <Form.Group controlId="stateIdNumber">
                  <Form.Label>
                    {t("pages.identity.verifyWithDL.stateIdNumber")}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onFieldValueChange(e, "stateIdNumber");
                    }}
                    value={stateIdNumber}
                    maxLength="4"
                    placeholder="####"
                    onBlur={(e) => {
                      this.isFormFieldValid(e, "stateIdNumberError");
                    }}
                    className={stateIdNumberError ? "error-input" : undefined}
                  />
                  <p className="error-text">
                    {stateIdNumberError && t(stateIdNumberError)}
                  </p>
                </Form.Group>
              </Col>
            </Form.Row>
          </div>
        </div>
        <div className="separator" />
        <div className="wrapper__container-card-footer">
          <Button
            className="wrapper__container-card-body-submit"
            size="lg"
            variant="primary"
            block
            type="submit"
            onClick={(e) => this.onNextClick(e)}
          >
            {t("pages.identity.next")}
            <img src={RightArrow} alt="" />
          </Button>
          <div className="wrapper__container-card-footer-link">
            <Button variant="link" className="wrapper__container-card-footer-link-btn" onClick={onBack}>{t("pages.identity.goBack")}</Button>
          </div>
        </div>
      </Form>
    );
  }
}

VerifyWithDL.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  userInfo: PropTypes.object,
  onNext: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

VerifyWithDL.defaultProps = {
  desc: "",
  userInfo: {},
};

export default withTranslation()(VerifyWithDL);
